import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  BulkAssemblyConstructsStructuredTableMetadata,
  BulkAssemblyConstructsStructuredTableRowMetadata,
} from 'molbio/bulk-assembly/tables/BulkAssemblyConstructsStructuredTableAdapter';
import {
  OverflowMenuActionFunction,
  TableActionFunctionParameters,
} from 'notebook/structured-tables/StructuredTableConstants';
import {BLUE_LIGHT, BLUE_POWDER} from 'ui-library/Colors';
import {OverflowMenuOption} from 'ui-library/menus/OverflowMenu';

export const toggleOverlapDetailsActionFunction: OverflowMenuActionFunction<
  BulkAssemblyConstructsStructuredTableMetadata,
  BulkAssemblyConstructsStructuredTableRowMetadata
> = {
  getOverflowMenuItem: (
    params: TableActionFunctionParameters<
      BulkAssemblyConstructsStructuredTableMetadata,
      BulkAssemblyConstructsStructuredTableRowMetadata
    >
  ): OverflowMenuOption => {
    const {
      structuredTable: {metadata},
    } = params;
    return {
      icon: 'check',
      iconClassName: metadata.showOverlapDetails ? css(styles.selected) : undefined,
      contentClassName: metadata.showOverlapDetails ? css(styles.selected) : undefined,
      contents: <span>Show overlap details</span>,
      onSelect: () => {
        metadata.onToggleOverlapDetails(!metadata.showOverlapDetails);
      },
    };
  },
};

const styles = StyleSheet.create({
  selected: {
    color: BLUE_LIGHT,
    backgroundColor: BLUE_POWDER,
  },
});
